module.exports = __webpack_public_path__ + "images/img-uAMO4eg.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/12.png
// module id = 2349
// module chunks = 0